import { render, staticRenderFns } from "./nickApply.vue?vue&type=template&id=614f0924&scoped=true&"
import script from "./nickApply.vue?vue&type=script&lang=js&"
export * from "./nickApply.vue?vue&type=script&lang=js&"
import style0 from "./nickApply.vue?vue&type=style&index=0&id=614f0924&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f0924",
  null
  
)

export default component.exports